// 所有的请求都放在该目录
import instance from "../utils/require";

// 激活网站
export function getIndexList(params) {
    return instance.post('/Api_Verification', params)
}

// 获取导航信息
export function getHeards(params) {
    return instance.get('/Column', {
        params
    })
}

// 获取轮播图信息
// http://website.renhegroup.net/index.php/Home/Index/Banner
export function getBanner(params) {
    return instance.get('/Banner', { params })
}

// 获取新闻列表信息
export function getNews(params) {
    return instance.get('/News', {
        params
    })
}

// 获取首页列表信息
// http://website.renhegroup.net/index.php/Home/Index/Product
export function GetHomePage(params) {
    return instance.get('/Product', {
        params
    })
}

// 获取二三级导航接口
// http://website.renhegroup.net/index.php/Home/Index/Column_Within
export function GetHomePage_Two(params) {
    return instance.get('/Column_Within', {
        params
    })
}

// 获取头部顶部信息
// 获取首页关于板块信息
export function GetHF(params) {
    return instance.get('/info', {
        params
    })
}

// 获取导航列表页信息
export function GetColumn_List(params) {
    return instance.get('/Column_List', {
        params
    })
}

// 首页简介
export function GetIndex_Show(params) {
    return instance.get('/Index_Show', {
        params
    })
}

// 获取导航底部信息
export function getFooter(params) {
    return instance.get('/Column', {
        params
    })
}

// 获取详情页信息
export function GetDetails(params) {
    return instance.get('/Details', {
        params
    })
}

// 获取友情链接数据
//http://website.renhegroup.net/index.php/Home/Index/Friend_Link?number=4&type=2
export function GetFriend_Link(params) {
    return instance.get('/Friend_Link', {
        params
    })
}


// 获取友情链接数据
//http://website.renhegroup.net/index.php/Home/Index/Product_Two
export function GetProduct_Two(params) {
    return instance.get('/Product_Two', {
        params
    })
}


// export function getIndexList(params) {
//     return instance({
//         url: 'v2_get_from',
//         method: 'get',
//         params
//     })
// }